import { Box } from '@mui/material';

const NoResults = ({ children, ...props }) => (
  <Box sx={{ background: '#d9edf7', borderRadius: '10px', textAlign: 'center', py: 5 }} {...props}>
    {children}
  </Box>
);

export default NoResults;
